<template>
  <div class="propertycontrol">
    <div class="header">
      <div class="title">生活服务</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="right">
        <div class="position">
          <img :src="mobileResidentOffice2" alt="" />
        </div>
      </div>

      <div class="left">
        社区有活动、公告通知，一键设置提醒，重要消息不再错过。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileResidentOffice2 from "../../../../assets/product/mobileResidentOffice2.png";

export default {
  setup() {
    return reactive({
      mobileResidentOffice2: mobileResidentOffice2,
    });
  },
};
</script>

<style scoped>
.propertycontrol {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .right .logo img {
  width: 332px;
}
.body .right .position img {
  width: 238px;
}
.body .right .position img:nth-of-type(1) {
  right: 100%;
}
.body .right .position img:nth-of-type(2) {
  right: 125%;
  bottom: 0;
}
.body .right .position img:nth-of-type(3) {
  right: 150%;
  bottom: 0;
}
.body .left {
  width: 92vw;
  margin: 22px auto 0;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
